module.exports = __webpack_public_path__ + "static/Writers-Print (3)-67d01e30d055b46e66e6251c98a4d34a.png";